import Icon from '@bugbug/core/components/Icon';
import styled from 'styled-components';

import InfoIcon from '~/images/info-icon.svg?react';

export const Description = styled.p`
  line-height: 1.5;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
  padding-right: 16px;
`;

export const ChangeParallelIcon = styled(Icon).attrs({
  name: 'upgradeColored',
  width: 48,
  height: 48,
})`
  flex-shrink: 0;
`;

export const LearnMoreLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};

  &:hover {
    text-decoration: underline;
  }
`;

export const ParallelSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 304px;
`;

export const ParallelSelectLabel = styled.p`
  line-height: 1.5;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  margin: 0;
`;

export const SummaryContainer = styled.div`
  border-radius: 5px;
  padding: 8px 12px;
  background-color: ${({ theme }) => theme.colors.background.highlight};
  display: flex;
  gap: 8px;
`;

export const UpgradeSummaryContainer = styled(SummaryContainer)`
  width: fit-content;
  align-items: center;
`;

export const UpgradeInfo = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
`;

export const UpgradePriceValue = styled.span`
  font-size: 15px;
  line-height: 1.5;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  margin-left: 12px;
`;

export const UpgradePriceCycle = styled.span`
  font-size: 13px;
  line-height: 1.5;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const UpgradeExtraInfo = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
`;

export const DowngradeInfoIcon = styled(InfoIcon)`
  margin: 2px 0;
  flex-shrink: 0;
`;

export const DowngradeInfoTitle = styled.p`
  line-height: 1.5;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin: 0;
`;

export const DowngradeInfoDescription = styled.p`
  line-height: 1.5;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
`;
